module.exports = __webpack_public_path__ + "static/media/NitorConnect.c71971f8.pdf";